<template>
	<div class="ibcontainer">
		<button class="ib medium" v-bind:style="{borderColor: border_color, backgroundColor: background_color, minWidth: min_width, maxWidth: max_width }" :disabled="disabled == false">
			<icon :name="icon" scale="1" :color="icon_color" class="ibi"></icon>&nbsp;&nbsp;<span
				v-bind:style="{color: text_color }">{{ text }}</span>
		</button>
	</div>
</template>

<script>
    export default {
        name: 'search',

        props: {
            disabled: {type: Boolean, default: false},
            icon: {type: String, default: "plus-circle"},
            text: {type: String, default: "action"},
            icon_color: {type: String, default: "black"},
            text_color: {type: String, default: "black"},
            border_color: {type: String, default: "black"},
            background_color: {type: String, default: "white"},
            min_width: { type: String, default: "250px"},
            max_width: { type: String, default: "250px"},

        }

    }
</script>


// WEBPACK FOOTER //
// Index.vue?a63b71b8